import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ReactComponent as UserCircle } from '../../assets/ilustraciones/user_circle.svg'
import Logo from '../../assets/img/logo.webp'
import IconTicket from '../../components/icons/IconTicket'
import { cn } from '../../utils/cn'
import { useAuthContext } from '../../hooks/useAuthContext'
import { routePaths } from '../../utils/constants'
import { TabsOptions } from '../../components/screenHome/Tabs'
import { pushInteractionEvent } from '../../services/gtmService'

type FooterProps = {
  setSelectedTab: React.Dispatch<React.SetStateAction<TabsOptions>>,
}

export default function Footer({ setSelectedTab }: FooterProps) {

  const navigate = useNavigate();
  const { userData } = useAuthContext();

  const handleProfileClick = () => {
    pushInteractionEvent('interaction_navbar','Perfil');
    if (userData.isLogged) {
      navigate('/' + routePaths.PROFILE)
    } else {
      navigate('/' + routePaths.LOGIN);
    }
  }
  
  const handleStoreClick = () => {
    pushInteractionEvent('interaction_navbar','Tus ahorros');
    if (userData.isLogged) {
      navigate('/' + routePaths.HISTORY);
    }
  }

  return (
    <div className="flex bg-white rounded-t-[40px] w-full h-28 pt-5 px-7 pb-4 gap-6 justify-between fixed bottom-0">
      <div id='buttonProfileFooter' className='flex flex-col gap-2 justify-center items-center w-[92px] cursor-pointer' onClick={handleProfileClick}>
        <UserCircle />
        <div className='text-blue_text font-roboto text-xs text-center'>Perfil</div>
      </div>
      <div id='buttonHome' className="flex flex-col gap-2 items-center w-[92px] cursor-pointer" onClick={() => setSelectedTab('promotions')}>
        <img className='drop-shadow-[0_4px_4px_#00000082]' src={Logo} alt="Logo descuentón" width={54} height={52.648} />
        <div className='text-blue_text font-roboto text-xs text-center'>Inicio</div>
      </div>
      <div id='buttonHistoryFooter' className='flex flex-col gap-2 justify-center items-center w-[92px] cursor-pointer' onClick={handleStoreClick}>
        <IconTicket fill={userData.isLogged ? '#070561' : '#95A2AD'} />
        <div className={cn('font-roboto text-xs text-center', userData.isLogged ? 'text-blue_text' : 'text-[#95A2AD]')}>Tus ahorros</div>
      </div>
    </div>
  )
}
